import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

import { MatDialog } from '@angular/material/dialog';

import { AdvanceSearchService } from '../../services/Advance-search/advance-search.service';
import { ToastService } from '../../services/toast/toast.service';
import { ManualEditNameComponent } from '../manual-update/manual-edit-name/manual-edit-name.component';
import { ManualEditAdhaarComponent } from './manual-edit-adhaar/manual-edit-adhaar.component';
import { ManualEditPhoneComponent } from './manual-edit-phone/manual-edit-phone.component';
import { ManualEditStatusComponent } from './manual-edit-status/manual-edit-status.component';

@Component({
  selector: 'app-manual-update',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './manual-update.component.html',
  styleUrl: './manual-update.component.scss',
})
export class ManualUpdateComponent implements OnInit {
  searchForm!: FormGroup;

  profileList: any[] = [];
  profileDetails: any[] = [];

  showCards = false;

  primaryMemberName: string = '';
  primaryFC: string = '';

  isMobile: boolean = window.innerWidth <= 768;
  name: string | null = null;

  constructor(
    private fb: FormBuilder,
    private advanceService: AdvanceSearchService,
    private dialog: MatDialog,
    private toaster: ToastService,
  ) {}

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      familyCode: ['', [Validators.required]],
    });
    this.name = localStorage.getItem('fullName');
  }

  searchByFamilyCode(): void {
    if (this.searchForm.invalid) return;

    const payload = {
      key: this.searchForm.value.familyCode,
      keyType: 'familyCode',
      page: 1,
    };

    this.advanceService.fetchProfile(payload).subscribe({
      next: (res: any) => {
        this.profileList = res?.data || [];
      },

      error: () => {
        this.profileList = [];
      },
    });
  }

  onRowClick(row: any): void {
    this.primaryMemberName =
      `${row.devoteeFirstName} ${row.devoteeMiddleName || ''} ${row.devoteeLastName}`.trim();

    this.primaryFC = row.devoteeFamilyCode;

    this.getProfileDetails(this.primaryFC);
  }

  getProfileDetails(fc: string): void {
    this.advanceService.fetchProfileDetails(fc).subscribe({
      next: (res: any) => {
        this.profileDetails = res?.data || [];

        this.showCards = true;
      },

      error: () => {
        this.profileDetails = [];
      },
    });
  }

  back(): void {
    this.showCards = false;
  }

  reset(): void {
    this.searchForm.reset();

    this.profileList = [];

    this.profileDetails = [];

    this.showCards = false;
  }

  onStatusToggle(item: any): void {
    const updatedStatus = item.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';

    const payload = {
      devoteeId: item.devoteeId,
      status: updatedStatus,
    };

    console.log(payload);

    // API CALL HERE

    // this.advanceService.updateStatus(payload).subscribe({
    //   next: () => {
    //     item.status = updatedStatus;
    //   },
    //   error: () => {
    //     console.log('Failed to update status');
    //   }
    // });
  }

  editName(item: any): void {
    console.log('edit name');

    const dialogRef = this.dialog.open(ManualEditNameComponent, {
      width: '500px',
      disableClose: true,

      data: {
        editType: item?.editType || 'Devotee',

        devoteeDetails: {
          devoteeFamilyCode: item?.devoteeFamilyCode,

          devoteeId: item?.devoteeId,

          devoteeFirstName: item?.devoteeFirstName,

          devoteeMiddleName: item?.devoteeMiddleName,

          devoteeLastName: item?.devoteeLastName,
        },
      },
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.getProfileDetails(this.primaryFC);
      }
    });
  }
  editAdhar(item: any): void {
    console.log('edit aadhaar');

    const dialogRef = this.dialog.open(ManualEditAdhaarComponent, {
      width: '500px',
      disableClose: true,

      data: {
        devoteeDetails: {
          devoteeFamilyCode: item?.devoteeFamilyCode,

          devoteeId: item?.devoteeId,

          aadhaarNumber: item?.aadhaarNumber,
        },
      },
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.getProfileDetails(this.primaryFC);
      }
    });
  }

  editPhone(item: any): void {
    const dialogRef = this.dialog.open(ManualEditPhoneComponent, {
      width: '500px',
      disableClose: true,

      data: {
        devoteeDetails: {
          devoteeFamilyCode: item?.devoteeFamilyCode,

          devoteeId: item?.devoteeId,

          contactNumber: item?.mobileNumber || item?.contactNumber,
        },
      },
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.getProfileDetails(this.primaryFC);
      }
    });
  }
  deletePhone(item: any): void {
    const payLoad = {
      familyCode: item?.devoteeFamilyCode,

      devoteeId: item?.devoteeId,

      deleteContactNumber: true,
    };

    this.advanceService.UpdateManualPhone(payLoad).subscribe({
      next: (res: any) => {
        this.toaster.success(res?.message || 'Contact number deleted');
        this.getProfileDetails(this.primaryFC);
      },

      error: (err: any) => {
        this.toaster.error(err?.error?.message || 'Failed to delete contact number');
      },
    });
  }
  updateStatus(item: any, status: string): void {
    // prevent clicking same status again
    if (item.status === status) return;

    const dialogRef = this.dialog.open(ManualEditStatusComponent, {
      width: '450px',
      disableClose: true,

      data: {
        devoteeId: item?.devoteeId,

        status: status,
      },
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        // update local UI
        item.status = status;

        // refresh list
        this.getProfileDetails(this.primaryFC);
      }
    });
  }
}
